import SearchResult from '../../models/SearchResult';
class SearchResultConverter {
    static convert({ ticker = 'AAPL', name = 'Apple inc.', exchange = 'US', previousClose = '123.45', country = 'USA' }) {
        return new SearchResult({ ticker, name, exchange, previousClose, country });
    }
}

export default SearchResultConverter
